import Footer from "./Footer";
import NavButton from "./NavButton";
import { Image, Text, Holder } from './Contact'
import AboutSection from "./About";
import { ProjectText, ProjectTitle, ProjectContainer } from './Projects'
import { NavList, NavListItem, Navigation } from "./Navigation";
import { Collapsible, TitleContainer, ContentContainer } from "./Accordion";
import styled from "styled-components";

export const Hr = styled.hr`
  display: block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  border-width: 1px;
`

export {
  Footer,
  NavButton,
  Image,
  Text,
  Holder,
  AboutSection,
  ProjectText,
  ProjectTitle,
  ProjectContainer,
  NavList,
  NavListItem,
  Navigation,
  Collapsible,
  TitleContainer,
  ContentContainer
};